import React from 'react';

export default function BrandMarquee({ brands, title }) {
  // Create many repetitions for seamless infinite wheel effect
  const repetitions = 8; // 8 copies of the brand set
  const infiniteBrands = Array(repetitions).fill(brands).flat();

  return (
    <div className="py-8 bg-slate-50 border-y border-slate-200 overflow-hidden">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        {title && (
          <p className="text-center text-sm text-slate-600 font-medium mb-6 uppercase tracking-wide">
            {title}
          </p>
        )}
        
        <div className="relative">
          {/* Scrolling container - seamless infinite loop */}
          <div className="flex animate-marquee-infinite items-center" style={{ height: '100px' }}>
            {infiniteBrands.map((brand, index) => (
              <div
                key={`${brand.name}-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="object-contain"
                  style={{ maxHeight: '80px', maxWidth: '200px' }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
